/**
 * Erreur d'API exploitable par l'interface.
 *
 * Le message vient du serveur et est déjà rédigé pour être lu par un parent : il ne doit
 * pas être réécrit côté client, sous peine de réintroduire un vocabulaire que le ton
 * éditorial du produit proscrit (docs/01 §5.5).
 */
export class ApiError extends Error {
    status;
    code;
    incidentId;
    constructor(status, body) {
        super(body?.message ?? 'Une erreur est survenue.');
        this.name = 'ApiError';
        this.status = status;
        this.code = body?.code ?? 'UNKNOWN';
        this.incidentId = body?.incidentId ?? null;
    }
    /** Session absente ou expirée : l'appelant doit tenter un renouvellement. */
    get isUnauthorized() {
        return this.status === 401;
    }
    /** Ressource inexistante — ou hors du périmètre de l'utilisateur, ce qui est indistinguable. */
    get isNotFound() {
        return this.status === 404;
    }
}
export class NetworkError extends Error {
    constructor(cause) {
        super("Le service est injoignable. Vérifiez votre connexion.", { cause });
        this.name = 'NetworkError';
    }
}
//# sourceMappingURL=errors.js.map